import classNames from 'classnames/bind';

import { MochiRadio } from '../mochi-radio';
import styles from './mochi-radio-group.module.sass';

const cx = classNames.bind(styles);

interface MochiRadioGroupProps {
  options: { label: string; value: string }[];
  value: string;
  spacing?: number;
  direction?: 'row' | 'column';
  onChange: (value: string) => void;
  className?: string;
}

export const MochiRadioGroup = ({
  options,
  value,
  direction = 'row',
  spacing = 0,
  onChange,
  className,
}: MochiRadioGroupProps) => {
  const radioStyles =
    direction === 'row'
      ? { marginLeft: `${spacing}px` }
      : { marginTop: `${spacing}px` };

  return (
    <div
      className={cx(
        {
          'mochi-radio-group': true,
          [`direction-${direction}`]: true,
        },
        className,
      )}
    >
      {options.map((o, i) => (
        <MochiRadio
          key={o.value}
          label={o.label}
          onClick={() => onChange(o.value)}
          isChecked={o.value === value}
          style={i !== 0 ? radioStyles : undefined}
        />
      ))}
    </div>
  );
};
